<template>
    <div>
        <div class="col-12 mb-4 d-flex justify-content-between align-items-baseline">
            <h4>Logs</h4>
        </div>
        <AppTable :columns="columns"
                  :rows="logs"
                  :query="query"
                  :loading="loading"
                  :total="total"
                  @on-query-change="onQueryChange">
            <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field === 'entity'">
                <span v-if="props.row.entity_type === 'orders'
                || props.row.entity_type === 'invoices'">
                {{ props.row.entity.number }}
                </span>
                <span v-if="props.row.entity_type === 'users'
                || props.row.entity_type === 'companies'
                || props.row.entity_type === 'warehouses'">
                {{ props.row.entity.name }}
                </span>
                <span v-if="props.row.entity_type === 'locations'">
                {{ props.row.entity.name }}
                </span>
                <span v-if="props.row.entity_type === 'order_lines' && props.row.entity.order">
                    Order: {{ props.row.entity.order.number }} <br>
                    Line product: {{ productName(props.row.entity.product) }}
                </span>
                <span v-if="props.row.entity_type === 'invoice_lines' && props.row.entity.invoice">
                    Invoice: {{ props.row.entity.invoice.number }} <br>
                    Line product: {{ productName(props.row.entity.product) }}
                </span>
            </span>
            <span v-else-if="props.column.field === 'changes'">
                <span v-for="changeLine in generateChanges(props.row)" :key="changeLine.id">
                    {{ changeLine }} <br>
                </span>
            </span>
                <span v-else>
                {{props.formattedRow[props.column.field]}}
            </span>
            </template>
        </AppTable>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import AppTable from '../form/AppTable';

export default {
  components: {
    AppTable,
  },
  computed: {
    ...mapGetters({
      logs: 'logs/logs',
    }),
    ...mapState({
      query: (state) => state.logs.query,
      total: (state) => state.logs.totalLogs,
    }),
    columns() {
      return [
        {
          label: 'Type',
          field: 'entity_type',
          filterOptions: {
            enabled: true,
          },
        },
        {
          label: 'Entity',
          field: 'entity',
          filterOptions: {
            enabled: true,
          },
        },
        {
          label: 'Action',
          field: 'operation_type',
          filterOptions: {
            enabled: true,
          },
        },
        {
          label: 'Changes',
          field: 'changes',
          filterOptions: {
            enabled: true,
          },
        },
        {
          label: 'Ip',
          field: 'ip',
          filterOptions: {
            enabled: true,
          },
        },
        {
          label: 'Changed at',
          field: 'created_at',
        },
      ];
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  mounted() {
    this.getLogs();
  },
  methods: {
    productName(product) {
      return product ? product.name : 'DELETED';
    },
    generateChanges(row) {
      const line = [];
      Object.keys(row.changes).forEach((key) => {
        if (row.prev_values && row.prev_values[key]) {
          line.push(`${key}: '${row.prev_values[key]}' => '${row.changes[key]}'`);
        } else {
          line.push(`${key}: '${row.changes[key]}'`);
        }
      });
      return line;
    },
    getLogs() {
      this.loading = true;

      this.$store.dispatch('logs/getLogs')
        .finally(() => {
          this.loading = false;
        });
    },
    onQueryChange(props) {
      this.$store.commit('logs/queryProps', props);
      this.getLogs();
    },
  },
};
</script>
